<div *ngIf="block"
    class="container-page-general position-relative d-flex flex-column justify-content-end align-items-center">
    <div *ngIf="!isSecondLevelUp" class="container-page-general__title w-100 text-center" [ngStyle]="{'margin-top': !block.field_immagine ? '180px' : ''}">
        <!-- TODO manca immagine da BC -->
        <img loading="lazy" *ngIf="block.field_immagine" [src]="imgPath" alt="image-person">
        <!-- <img loading="lazy" src="https://images.unsplash.com/flagged/photo-1570612861542-284f4c12e75f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80" alt=""> -->
        <h1 *ngIf="block.field_nome && block.field_cognome" class="ls-h1-page-title text-brand-10 text-start text-lg-center px-3 px-lg-0 mb-4" [innerHTML]="block.field_nome + ' ' + block.field_cognome"></h1>
        <p *ngIf="block.field_posizione" class="text-neutral-40 ls-p mb-0" [innerHTML]="block.field_posizione"></p>
    </div>
</div>
<ng-container *ngIf="node && block && isSpinner; else spinner">
    <div class="container-field-taxonomies">
        <!-- DEFAULT PAGINA FIELD -->
        <app-container-field-taxonomies [dataFieldTaxonomies]="dataFieldTaxonomies" [typeOfContent]="'persona'">
        </app-container-field-taxonomies>
        <!-- END DEFAULT PAGINA FIELD -->
    </div>
    <!-- Anchor -->
    <app-sample-anchor *ngIf="anchorItems && !isSecondLevelUp" [anchorItems]="anchorItems" [idAnchor]="idAnchor"
        [positionType]="'mt-2'" [bgColor]="'white'" [setOffset]="250" [positionTop]="'120px'" [styleHeader]="'second'">
    </app-sample-anchor>
    <!-- END Anchor -->
    <!-- HEADER COLLAPSE -->
    <div *ngIf="block && node" id="collapse" [ngClass]="{
        'opacity-100 visible bg-neutral-A1': isCollapseHeader,
        'opacity-0 invisible bg-neutral-99': !isCollapseHeader
        }" class="container-page-general-collapse position-fixed no-print">
        <div class="container-page-general-collapse__item text-md-center d-flex justify-content-between align-items-center border-bottom-custom">
            <div *ngIf="isShowLocalMenu" class="d-flex align-items-end container-icon-expand m-auto col-1">
                <img loading="lazy" *ngIf="isSecondLevelUp" class="cursor-pointer hidden-phone"
                    src="../../../../../../assets/images/side-menu-expand.svg" alt="menu expand"
                    style="margin-left: 34px;" (click)="openMenu()">
            </div>
            <p *ngIf="block.field_nome && block.field_cognome" class="ls-h1-page-title-collapse col-10 mb-1" [ngClass]="{'offset-1': !isShowLocalMenu}"
                [innerHTML]="block.field_nome + ' ' + block.field_cognome">
        </p>
            <div class="d-flex justify-content-end align-items-center col-1" [ngClass]="{
                'col-1': titlePage && isShowLocalMenu,
                'col-11': !titlePage && isShowLocalMenu,
                'col-12': !titlePage && !isShowLocalMenu
            }">
                <div class="cursor-pointer" (click)="nodeService.openModaleShare()">
                    <img loading="lazy" src="../../../../../../assets/images/share-icon/share-icon-yellow.png" alt="share icon"
                        style="margin-right: 34px;">
                </div>
            </div>
        </div>
        <div *ngIf="!isSecondLevelUp && anchorItems.length" class="border-bottom-custom" style="padding: 16px 10px;">
            <app-sample-anchor *ngIf="anchorItems" [anchorItems]="anchorItems" [styleHeader]="'collapse'"
                [positionTop]="'140px'" [bgColor]="'transparent'" [setOffset]="250">
            </app-sample-anchor>
        </div>
    </div>
    <!-- END HEADER COLLAPSE -->
    <!-- CONTACT -->
    <div class="container container-contact">
        <div class="container-contact__item" *ngIf="block.field_indirizzo_email">
            <h3 class="ls-h3-item-title-small text-brand-10" [innerHTML]="'CONTENT_TYPES.PAGE_PERSONA.CONTACT' | translate"></h3>
            <a class="ls-p text-brand-40" [href]="'mailto:'+ block.field_indirizzo_email" [innerHTML]="block.field_indirizzo_email"></a>
        </div>
        <div class="container-contact__item" *ngIf="block.field_ricerca_in_corso">
            <h3 class="ls-h3-item-title-small text-brand-10" [innerHTML]="'CONTENT_TYPES.PAGE_PERSONA.RESEARCH_TITLE' | translate"></h3>
            <p class="ls-p text-neutral-30 m-0" [innerHTML]="block.field_ricerca_in_corso"></p>
        </div>
        <div class="container-contact__item" *ngIf="block.field_periodo_di_ricerca_all_est">
            <h3 class="ls-h3-item-title-small text-brand-10" [innerHTML]="'CONTENT_TYPES.PAGE_PERSONA.RESEARCH_PERIODS' | translate"></h3>
            <p class="ls-p text-neutral-30 m-0" [innerHTML]="block.field_periodo_di_ricerca_all_est"></p>
        </div>
    </div>
    <!-- END CONTACT -->
    <!-- AREE DI RICERCA -->
    <div class="container-ricerca" *ngIf="keywords && keywords.length">
        <p class="container-ricerca__text ls-label-small-semibold text-uppercase text-brand-10 text-center">
            {{"CONTENT_TYPES.PAGE_PERSONA.RESEARCH_AREAS" | translate}}
        </p>
    <div class="container-ricerca__keywords d-flex flex-wrap justify-content-center">
        <p *ngFor="let item of keywords"
            class="bg-neutral-95 text-support-30 ls-label-small-semibold text-uppercase"
            [innerHTML]="item.name"></p>
    </div>
    </div>
    <!-- END AREE DI RICERCA -->
    <!-- PUBBLICAIONI -->
    <div class="container">
        <div *ngIf="pubblicazioniFirst && pubblicazioniFirst.length" class="container-all-pubblications mt-5">
            <div class="container-all-pubblications__container-title bg-brand-99 d-flex justify-content-center align-items-center">
                <p class="ls-label-medium-semibold text-uppercase text-brand-40 text-center m-0">
                    {{"CONTENT_TYPES.PAGE_DOCENTI.ALL_PUBLICATIONS" | translate}}
                </p>
            </div>
            <div class="container-all-pubblications__container-items">
                <ul>
                    <li *ngFor="let pubblicazione of pubblicazioniFirst">
                        <a [href]="pubblicazione.link" target="_blank" [innerHTML]="pubblicazione.description"></a>
                    </li>
                    <ng-container *ngIf="isOtherPub">
                        <li *ngFor="let pubblicazione of pubblicazioniOther">
                            <a [href]="pubblicazione.link" target="_blank" [innerHTML]="pubblicazione.description"></a>
                        </li>
                    </ng-container>
                </ul>
                <div class="pt-4 d-flex justify-content-center align-items-center">
                    <p class="text-uppercase ls-label-small-semibold text-brand-40 m-0 d-flex cursor-pointer" (click)="isOtherPub = !isOtherPub">
                        {{ (!isOtherPub ? 'CONTENT_TYPES.PAGE_DOCENTI.SHOW_ALL' : 'CONTENT_TYPES.PAGE_DOCENTI.SHOW_LESS') | translate }}
                    </p>    
                </div>
            </div>
        </div>
    </div>
    <!-- END PUBBLICAIONI -->
    <ng-container *ngIf="node.field_layout_righe && node.field_layout_righe.length">
        <div class="container-row">
            <div *ngFor="let row of node.field_layout_righe; let idx = index">
                <app-row [lang]="node.langcode[0].value" [rowId]="row.target_id" [position]="idx" [attr.rowid]="row.target_id"
                    [preview]="node.preview" (objAnchor)="addNewAnchorItem($event)">
                </app-row>
            </div>
        </div>
    </ng-container>
    <div *ngIf="node.created[0].value" class="mt-5 mb-5 d-flex flex-wrap justify-content-between w-100 container container-published" style="gap: 20px 0;">
        <div class="col-12 col-sm-8 order-1 ordder-sm-0">
            <div class="d-flex w-100 mb-2">
                <p class="text-neutral-30 ls-label-medium-semibold mb-0 me-1">
                    {{ "CONTENT_TYPES.CONTENT_PUBLISHED" | translate }}
                </p>
                <p class="text-neutral-30 ls-label-medium-semibold mb-0">
                    {{ node.created[0].value | localizedDate: 'dd MMMM yyyy - HH:MM'}}
                </p>
            </div>
            <div class="d-flex w-100" *ngIf="node.changed[0].value">
                <p class="text-neutral-30 ls-p-small mb-0 me-1">
                    {{ "CONTENT_TYPES.LAST_MODIFIED" | translate }}
                </p>
                <p class="text-neutral-30 ls-p-small mb-0">
                    {{ node.changed[0].value | localizedDate: 'dd MMMM yyyy - HH:MM'}}
                </p>
            </div>
        </div>
        <div class="container-page-general__container-share cursor-pointer col-12 col-sm-4 col-md-3 order-0 order-sm-1" (mouseenter)="onHoverShare = true"
            (mouseleave)="onHoverShare = false" (click)="nodeService.openModaleShare()">
            <p class="m-0 ls-label-medium-semibold text-uppercase">{{"MODAL_SHARE.SEND_TO" | translate}}</p>
            <img loading="lazy" src="../../../../../../assets/images/share-icon/share-icon-yellow.png" alt="share icon">
        </div>
    </div>
    </ng-container>
<ng-template #spinner>
    <app-spinner></app-spinner>
</ng-template>